import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { agriculture } from '../../../skills/agriculture';
import { artscraft } from '../../../skills/artscraft';
import { business } from '../../../skills/business';
import { creative } from '../../../skills/creative';
import { construction } from '../../../skills/construction';
import { engineering } from '../../../skills/engineering';
import { film } from '../../../skills/film';
import { governmenteducation } from '../../../skills/governmenteducation';
import { healthbeautywellbeing } from '../../../skills/healthbeautywellbeing';
import { homeservices } from '../../../skills/homeservices';
import { hospitality } from '../../../skills/hospitality';
import { it } from '../../../skills/it';
import { music } from '../../../skills/music';
import { sports } from '../../../skills/sports';
import { theatre } from '../../../skills/theatre';
import { transport } from '../../../skills/transport';

@Component({
    imports: [CommonModule],
    selector: 'feature-skills',
    styleUrls: ['./feature-skills.scss'],
    templateUrl: './feature-skills.html',
    standalone: true
})
export class FeatureSkillsComponent implements OnInit {
  @Input() code: string = '';
  @Input() country: string = '';
  @Input() slug: string = '';
  @Input() grouping: any = [];
  @Input() classification: any = [];
  @Input() service: string = '';
  mediaURL: string = environment.mediaURL;
  webURL: string = 'https://gigexchange.com';
  subdomain: string = '';
  agriculture$: any[] = Object.values(agriculture);
  artscraft$: any[] = Object.values(artscraft);
  business$: any[] = Object.values(business);
  construction$: any[] = Object.values(construction);
  creative$: any[] = Object.values(creative);
  engineering$: any[] = Object.values(engineering);
  film$: any[] = Object.values(film);
  governmenteducation$: any[] = Object.values(governmenteducation);
  healthbeauty$: any[] = Object.values(healthbeautywellbeing);
  homeservices$: any[] = Object.values(homeservices);
  hospitality$: any[] = Object.values(hospitality);
  it$: any[] = Object.values(it);
  music$: any[] = Object.values(music);
  sports$: any[] = Object.values(sports);
  theatre$: any[] = Object.values(theatre);
  transport$: any[] = Object.values(transport);
  agricultureservices: any = [];
  artscraftservices: any = [];
  businessservices: any = [];
  constructionservices: any = [];
  creativeservices: any = [];
  engineeringservices: any = [];
  filmservices: any = [];
  governmenteducationservices: any = [];
  healthbeautyservices: any = [];
  homeservices: any = [];
  hospitalityservices: any = [];
  itservices: any = [];
  musicservices: any = [];
  sportsservices: any = [];
  theatreservices: any = [];
  transportservices: any = [];
  duplicateservices: any = [];
  featured: any = [];
  skills: any = [];
  industry: string = '';
  link: string = '';

  constructor(
  ) { }

  ngOnInit() {
    this.subdomain = 'https://' + this.code.toLowerCase() + '.gigexchange.com';

    if (this.grouping.indexOf('Agriculture & Conservation') !== -1) {
      this.agriculture$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/agriculture-conservation/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'agriculture-conservation'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.agricultureservices.push(newskill);
        }
      })
      this.agricultureservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.agricultureservices];
      this.industry = 'Agriculture & Conservation';
      this.link = this.subdomain + '/services/agriculture-conservation/' + this.slug;
    }

    if (this.grouping.indexOf('Arts') !== -1) {
      this.artscraft$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/arts-craft/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'arts-craft'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.artscraftservices.push(newskill);
        }
      })
      this.artscraftservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.artscraftservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'arts-craft',
            name: 'Arts',
            url: this.subdomain + '/services/arts-craft/' + this.slug,
            classification: ['Arts'],
            industry: 'arts-craft'  
          }
        ]
      }
      this.industry = 'Arts';
      this.link = this.subdomain + '/services/arts-craft/' + this.slug;
    }

    if (this.grouping.indexOf('Business') !== -1) {
      this.business$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/business/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'business'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.businessservices.push(newskill);
        }
      })
      this.businessservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.businessservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'business',
            name: 'Business',
            url: this.subdomain + '/services/business/' + this.slug,
            classification: ['Business'],
            industry: 'business'
          }
        ]
      }
      this.industry = 'Business';
      this.link = this.subdomain + '/services/business/' + this.slug;
    }

    if (this.grouping.indexOf('Construction') !== -1) {
      this.construction$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/construction/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'construction'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.constructionservices.push(newskill);
        }
      })
      this.constructionservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.constructionservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'construction',
            name: 'Construction',
            url: this.subdomain + '/services/construction/' + this.slug,
            classification: ['Construction'],
            industry: 'construction'
          }
        ]
      }
      this.industry = 'Construction';
      this.link = this.subdomain + '/services/construction/' + this.slug;
    }

    if (this.grouping.indexOf('Creative') !== -1) {
      this.creative$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/creative/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'creative'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.creativeservices.push(newskill);
        }
      })
      this.creativeservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.creativeservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'creative',
            name: 'Creative',
            url: this.subdomain + '/services/creative/' + this.slug,
            classification: ['Creative'],
            industry: 'creative'
          }
        ]
      }
      this.industry = 'Creative';
      this.link = this.subdomain + '/services/creative/' + this.slug;
    }

    if (this.grouping.indexOf('Engineering & Manufacturing') !== -1) {
      this.engineering$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/engineering-manufacturing/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'engineering-manufacturing'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.engineeringservices.push(newskill);
        }
      })
      this.engineeringservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.engineeringservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'engineering-manufacturing',
            name: 'Engineering & Manufacturing',
            url: this.subdomain + '/services/engineering-manufacturing/' + this.slug,
            classification: ['Engineering & Manufacturing'],
            industry: 'engineering-manufacturing'
          }
        ]
      }
      this.industry = 'Engineering & Manufacturing';
      this.link = this.subdomain + '/services/engineering-manufacturing/' + this.slug;
    }

    if (this.grouping.indexOf('Film') !== -1) {
      this.film$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/film/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'film'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.filmservices.push(newskill);
        }
      })
      this.filmservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.filmservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'film',
            name: 'Film',
            url: this.subdomain + '/services/film/' + this.slug,
            classification: ['Film'],
            industry: 'film'
          }
        ]
      }
      this.industry = 'Film';
      this.link = this.subdomain + '/services/film/' + this.slug;
    }

    if (this.grouping.indexOf('Education & Government') !== -1) {
      this.governmenteducation$.forEach((skill, i) => {
      let newskill = {
          id: i - 1,
          image: skill.slugimage,
          name: skill.nameservice,
          url: this.subdomain + '/services/government-education/' + skill.slugservice + '/' + this.slug,
          classification: skill.classification,
          industry: 'government-education'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.governmenteducationservices.push(newskill);
        }
      })
      this.governmenteducationservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.governmenteducationservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'government-education',
            name: 'Education & Government',
            url: this.subdomain + '/services/government-education/' + this.slug,
            classification: ['Education & Government'],
            industry: 'government-education'
          }
        ]
      }
      this.industry = 'Education & Government';
      this.link = this.subdomain + '/services/government-education/' + this.slug;
    }

    if (this.grouping.indexOf('Health, Beauty & Wellbeing') !== -1) {
      this.healthbeauty$.forEach((skill, i) => {
      let newskill = {
          id: i - 1,
          image: skill.slugimage,
          name: skill.nameservice,
          url: this.subdomain + '/services/health-beauty/' + skill.slugservice + '/' + this.slug,
          classification: skill.classification,
          industry: 'health-beauty'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.healthbeautyservices.push(newskill);
        }
      })
      this.healthbeautyservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.healthbeautyservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'health-beauty',
            name: 'Health, Beauty & Wellbeing',
            url: this.subdomain + '/services/health-beauty/' + this.slug,
            classification: ['Health, Beauty & Wellbeing'],
            industry: 'health-beauty'
          }
        ]
      }
      this.industry = 'Health, Beauty & Wellbeing';
      this.link = this.subdomain + '/services/health-beauty/' + this.slug;
    }

    if (this.grouping.indexOf('Home Services') !== -1) {
      this.homeservices$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/home-services/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'home-services'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.homeservices.push(newskill);
        }
      })
      this.homeservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1));
      this.skills = [...this.homeservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'home-services',
            name: 'Home Services',
            url: this.subdomain + '/services/home-services/' + this.slug,
            classification: ['Home Services'],
            industry: 'home-services'
          }
        ]
      }
      this.industry = 'Home Services';
      this.link = this.subdomain + '/services/home-services/' + this.slug;
    }

    if (this.grouping.indexOf('Hospitality, Tourism & Retail') !== -1) {
      this.hospitality$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/hospitality/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'hospitality'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.hospitalityservices.push(newskill);
        }
      })
      this.hospitalityservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.hospitalityservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'hospitality',
            name: 'Hospitality, Tourism & Retail',
            url: this.subdomain + '/services/hospitality/' + this.slug,
            classification: ['Hospitality, Tourism & Retail'],
            industry: 'hospitality'
          }
        ]
      }
      this.industry = 'Hospitality, Tourism & Retail';
      this.link = this.subdomain + '/services/hospitality/' + this.slug;
    }

    if (this.grouping.indexOf('Information Technology') !== -1) {
      this.it$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/it/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'it'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.itservices.push(newskill);
        }
      })
      this.itservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.itservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'it',
            name: 'Information Technology',
            url: this.subdomain + '/services/it/' + this.slug,
            classification: ['Information Technology'],
            industry: 'it'
          }
        ]
      }
      this.industry = 'Information Technology';
      this.link = this.subdomain + '/services/it/' + this.slug;
    }

    if (this.grouping.indexOf('Music') !== -1) {
      this.music$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/music/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'music'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.musicservices.push(newskill);
        }
      })
      this.musicservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.musicservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'music',
            name: 'Music',
            url: this.subdomain + '/services/music/' + this.slug,
            classification: ['Music'],
            industry: 'music'
          }
        ]
      }
      this.industry = 'Music';
      this.link = this.subdomain + '/services/music/' + this.slug;
    }

    if (this.grouping.indexOf('Sport') !== -1) {
      this.sports$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/sports/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'sport'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.sportsservices.push(newskill);
        }
      })
      this.sportsservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.sportsservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'sport',
            name: 'Sport',
            url: this.subdomain + '/services/sports/' + this.slug,
            classification: ['Sport'],
            industry: 'sport'
          }
        ]
      }
      this.industry = 'Sport';
      this.link = this.subdomain + '/services/sports/' + this.slug;
    }

    if (this.grouping.indexOf('Theatre') !== -1) {
      this.theatre$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/theatre/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'theatre'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.theatreservices.push(newskill);
        }
      })
      this.theatreservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.theatreservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'theatre',
            name: 'Theatre',
            url: this.subdomain + '/services/theatre/' + this.slug,
            classification: ['Theatre'],
            industry: 'theatre'
          }
        ]
      }
      this.industry = 'Theatre';
      this.link = this.subdomain + '/services/theatre/' + this.slug;
    }

    if (this.grouping.indexOf('Transport & Mining') !== -1) {
      this.transport$.forEach((skill, i) => {
        let newskill = {
            id: i - 1,
            image: skill.slugimage,
            name: skill.nameservice,
            url: this.subdomain + '/services/transport-mining/' + skill.slugservice + '/' + this.slug,
            classification: skill.classification,
            industry: 'transport-mining'
        }
        if (skill.classification.indexOf(this.classification[0]) !== -1 || skill.classification.indexOf(this.classification[1]) !== -1 || skill.classification.indexOf(this.classification[2]) !== -1) {
          this.transportservices.push(newskill);
        }
      })
      this.transportservices.sort((a: { name: number; },b: { name: number; })=> (a.name > b.name ? 1 : -1))
      this.skills = [...this.transportservices];
      if (this.skills.length == 0) {
        this.skills = [
          {
            id: 0,
            image: 'transport-mining',
            name: 'Transport & Mining',
            url: this.subdomain + '/services/transport-mining/' + this.slug,
            classification: ['Transport & Mining'],
            industry: 'transport-mining'
          }
        ]
      }
      this.industry = 'Transport & Mining';
      this.link = this.subdomain + '/services/transport-mining/' + this.slug;
    }
    
    const shuffled = this.skills.sort(() => 0.5 - Math.random());
    // this.featured = shuffled.slice(0, 4);
    // console.log('this.featured',this.featured);
    this.skills = shuffled.slice(0, 12);
    // console.log('this.skills',this.skills);
  }
}
